import { Query } from 'graphql/generated/graphqlTypes';
import { mockVisitorGroupsInstallersAndCleaners } from 'mocks/graphqlMocks/visitorGroupFixtures';

export function mockedGetAllVisitorsVisitorGroupsData(
  getVisitorGroupsForTenant: Query['getVisitorGroupsForTenant']
): Pick<Query, 'getVisitorGroupsForTenant'> {
  return { getVisitorGroupsForTenant };
}

export const mockedGetAllVisitorsVisitorGroupsDataForQuery = mockedGetAllVisitorsVisitorGroupsData(
  mockVisitorGroupsInstallersAndCleaners
);
